export const LIST_CORPORATE = 'src/Admin/Corporate/List/LIST_CORPORATE';
export const LIST_CORPORATE_SUCCESS = 'src/components/Corporate/Create/action/LIST_CORPORATE_Success';
export const LIST_CORPORATE_FAILURE = 'src/components/Corporate/Create/action/LIST_CORPORATE_Failure';

export const listCorporate = (data) => {
    return {
        type: LIST_CORPORATE,
        data
    }
}
export const listCorporateSuccess = (data) => {
    return {
        type: LIST_CORPORATE_SUCCESS,
        data
    }
}
export const listCorporateFailure = (error) => {
    return {
        type: LIST_CORPORATE_FAILURE,
        error
    }
}

export const TRANSACTION_CHECK_EXIST = 'src/Admin/Corporate/List/action/Transaction_Check_Exist';
export const TRANSACTION_CHECK_EXIST_SUCCESS = 'src/Admin/Corporate/List/action/Transaction_Check_Exist_Success';
export const TRANSACTION_CHECK_EXIST_FAILURE = 'src/Admin/Corporate/List/action/Transaction_Check_Exist_Failure';

export const transactionDataCheck = (data) => {
    return {
        type: TRANSACTION_CHECK_EXIST,
        data
    }
}
export const transactionDataCheckSuccess = (data) => {
    return {
        type: TRANSACTION_CHECK_EXIST_SUCCESS,
        data
    }
}
export const transactionDataCheckFailure = (data) => {
    return {
        type: TRANSACTION_CHECK_EXIST_FAILURE,
        data
    }
}

export const TRANSACTION_DATA_FILE_UPLOAD = 'src/Admin/Corporate/List/action/Transaction_Data_File_Upload';
export const TRANSACTION_DATA_FILE_UPLOAD_SUCCESS = 'src/Admin/Corporate/List/action/Transaction_Data_File_Upload_Success';
export const TRANSACTION_DATA_FILE_UPLOAD_FAILURE = 'src/Admin/Corporate/List/action/Transaction_Data_File_Upload_Failure';

export const transactionDataFileUpload = (data) => {
    return {
        type: TRANSACTION_DATA_FILE_UPLOAD,
        data
    }
}
export const transactionDataFileUploadSuccess = (data) => {
    return {
        type: TRANSACTION_DATA_FILE_UPLOAD_SUCCESS,
        data
    }
}
export const transactionDataFileUploadFailure = (data) => {
    return {
        type: TRANSACTION_DATA_FILE_UPLOAD_FAILURE,
        data
    }
}
export const TRANSACTION_DATA_LIST = 'src/Admin/Corporate/List/action/Transaction_Data_List';
export const TRANSACTION_DATA_LIST_SUCCESS = 'src/Admin/Corporate/List/action/Transaction_Data_List_Success';
export const TRANSACTION_DATA_LIST_FAILURE = 'src/Admin/Corporate/List/action/Transaction_Data_List_Failure';

export const transactionDataList = (data) => {
    return {
        type: TRANSACTION_DATA_LIST,
        data
    }
}
export const transactionDataListSuccess = (data) => {
    return {
        type: TRANSACTION_DATA_LIST_SUCCESS,
        data
    }
}
export const transactionDataListFailure = (data) => {
    return {
        type: TRANSACTION_DATA_LIST_FAILURE,
        data
    }
}

export const DOWNLOAD_TRANSACTION_TEMPLATE = 'src/Admin/Corporate/List/action/Download_Transaction_Template';
export const DOWNLOAD_TRANSACTION_TEMPLATE_SUCCESS = 'src/Admin/Corporate/List/action/Download_Transaction_Template_Success';
export const DOWNLOAD_TRANSACTION_TEMPLATE_FAILURE = 'src/Admin/Corporate/List/action/Download_Transaction_Template_Failure';

export const downloadTransactionTemplate = (data) => {
    return {
        type: DOWNLOAD_TRANSACTION_TEMPLATE,
        data
    }
}
export const downloadTransactionTemplateSuccess = (data) => {
    return {
        type: DOWNLOAD_TRANSACTION_TEMPLATE_SUCCESS,
        data
    }
}
export const downloadTransactionTemplateFailure = (data) => {
    return {
        type: DOWNLOAD_TRANSACTION_TEMPLATE_FAILURE,
        data
    }
}

export const DELETE_TRANSACTION_DATA = 'src/Admin/Corporate/List/action/Delete_Transaction_Data';
export const DELETE_TRANSACTION_DATA_SUCCESS = 'src/Admin/Corporate/List/action/Delete_Transaction_Data_Success';
export const DELETE_TRANSACTION_DATA_FAILURE = 'src/Admin/Corporate/List/action/Delete_Transaction_Data_Failure';

export const deleteTransactionData = (data) => {
    return {
        type: DELETE_TRANSACTION_DATA,
        data
    }
}
export const deleteTransactionDataSuccess = (data) => {
    return {
        type: DELETE_TRANSACTION_DATA_SUCCESS,
        data
    }
}
export const deleteTransactionDataFailure = (data) => {
    return {
        type: DELETE_TRANSACTION_DATA_FAILURE,
        data
    }
}

export const DOWNLOAD_TRANSACTION_FILE = 'src/Admin/Corporate/List/action/Download_Transaction_File';
export const DOWNLOAD_TRANSACTION_FILE_SUCCESS = 'src/Admin/Corporate/List/action/Download_Transaction_File_Success';
export const DOWNLOAD_TRANSACTION_FILE_FAILURE = 'src/Admin/Corporate/List/action/Download_Transaction_File_Failure';

export const downloadTransactionFile = (data) => {
    return {
        type: DOWNLOAD_TRANSACTION_FILE,
        data
    }
}
export const downloadTransactionFileSuccess = (data) => {
    return {
        type: DOWNLOAD_TRANSACTION_FILE_SUCCESS,
        data
    }
}
export const downloadTransactionFileFailure = (data) => {
    return {
        type: DOWNLOAD_TRANSACTION_FILE_FAILURE,
        data
    }
}
export const DOWNLOAD_EXCEL_FILE = 'src/Admin/Corporate/List/action/Download_Excel_File';
export const DOWNLOAD_EXCEL_FILE_SUCCESS = 'src/Admin/Corporate/List/action/Download_Excel_File_Success';
export const DOWNLOAD_EXCEL_FILE_FAILURE = 'src/Admin/Corporate/List/action/Download_Excel_File_Failure';


export const downloadExcelFile = (data) => {
    return {
        type: DOWNLOAD_EXCEL_FILE,
        data
    }
}

export const downloadExcelFileSuccess = (data) => {
    return {
        type: DOWNLOAD_EXCEL_FILE_SUCCESS,
        data
    }
}
export const downloadExcelFileFailure = (data) => {
    return {
        type: DOWNLOAD_EXCEL_FILE_FAILURE,
        data
    }
}

export const DOWNLOAD_NON_FINANCIAL_EXCEL_FILE = 'src/Admin/Corporate/List/action/Download_Non_Financial_Excel_File';
export const DOWNLOAD_NON_FINANCIAL_EXCEL_FILE_SUCCESS = 'src/Admin/Corporate/List/action/Download_Non_Financial_Excel_File_Success';
export const DOWNLOAD_NON_FINANCIAL_EXCEL_FILE_FAILURE = 'src/Admin/Corporate/List/action/Download_Non_Financial_Excel_File_Failure';


export const downloadNonFinancialExcelFile = (data) => {
    return {
        type: DOWNLOAD_NON_FINANCIAL_EXCEL_FILE,
        data
    }
}

export const downloadNonFinancialExcelFileSuccess = (data) => {
    return {
        type: DOWNLOAD_NON_FINANCIAL_EXCEL_FILE_SUCCESS,
        data
    }
}
export const downloadNonFinancialExcelFileFailure = (data) => {
    return {
        type: DOWNLOAD_NON_FINANCIAL_EXCEL_FILE_FAILURE,
        data
    }
}


export const DOWNLOAD_OBJECT_LIST_EXCEL_FILE = 'src/Admin/Corporate/List/action/Download_Object_List_Excel_File';
export const DOWNLOAD_OBJECT_LIST_EXCEL_FILE_SUCCESS = 'src/Admin/Corporate/List/action/Download_Object_List_Excel_File_Success';
export const DOWNLOAD_OBJECT_LIST_EXCEL_FILE_FAILURE = 'src/Admin/Corporate/List/action/Download_Object_List_Excel_File_Failure';


export const downloadObjectListExcelFile = (data) => {
    return {
        type: DOWNLOAD_OBJECT_LIST_EXCEL_FILE,
        data
    }
}

export const downloadObjectListExcelFileSuccess = (data) => {
    return {
        type: DOWNLOAD_OBJECT_LIST_EXCEL_FILE_SUCCESS,
        data
    }
}
export const downloadObjectListExcelFileFailure = (data) => {
    return {
        type: DOWNLOAD_OBJECT_LIST_EXCEL_FILE_FAILURE,
        data
    }
}

export const DOWNLOAD_SCORE_BREAKUP_EXCEL_FILE = 'src/Admin/Corporate/List/action/Download_Score_Breakup_Excel_File';
export const DOWNLOAD_SCORE_BREAKUP_EXCEL_FILE_SUCCESS = 'src/Admin/Corporate/List/action/Download_Score_Breakup_Excel_File_Success';
export const DOWNLOAD_SCORE_BREAKUP_EXCEL_FILE_FAILURE = 'src/Admin/Corporate/List/action/Download_Score_Breakupcel_File_Failure';

export const downloadScoreBreakupExcelFile = (data) => {
    return {
        type: DOWNLOAD_SCORE_BREAKUP_EXCEL_FILE,
        data
    }
}

export const downloadScoreBreakupExcelFileSuccess = (data) => {
    return {
        type: DOWNLOAD_SCORE_BREAKUP_EXCEL_FILE_SUCCESS,
        data
    }
}
export const downloadScoreBreakupExcelFileFailure = (data) => {
    return {
        type: DOWNLOAD_SCORE_BREAKUP_EXCEL_FILE_FAILURE,
        data
    }
}

export const DOWNLOAD_CLM_BREAKUP_EXCEL_FILE = 'src/Admin/Corporate/List/action/Download_CLM_Breakup_Excel_File';
export const DOWNLOAD_CLM_BREAKUP_EXCEL_FILE_SUCCESS = 'src/Admin/Corporate/List/action/Download_CLM_Breakup_Excel_File_Success';
export const DOWNLOAD_CLM_BREAKUP_EXCEL_FILE_FAILURE = 'src/Admin/Corporate/List/action/Download_CLM_Breakup_Excel_File_Failure';

export const downloadCLMBreakupExcelFile = (data) => {
    return {
        type: DOWNLOAD_CLM_BREAKUP_EXCEL_FILE,
        data
    }
}

export const downloadCLMBreakupExcelFileSuccess = (data) => {
    return {
        type: DOWNLOAD_CLM_BREAKUP_EXCEL_FILE_SUCCESS,
        data
    }
}
export const downloadCLMBreakupExcelFileFailure = (data) => {
    return {
        type: DOWNLOAD_CLM_BREAKUP_EXCEL_FILE_FAILURE,
        data
    }
}

// CSV Download Action Types
export const DOWNLOAD_CORPORATE_CSV_REQUEST = 'src/Admin/Corporate/List/action/DOWNLOAD_CORPORATE_CSV_REQUEST';
export const DOWNLOAD_CORPORATE_CSV_SUCCESS = 'src/Admin/Corporate/List/action/DOWNLOAD_CORPORATE_CSV_SUCCESS';
export const DOWNLOAD_CORPORATE_CSV_FAILURE = 'src/Admin/Corporate/List/action/DOWNLOAD_CORPORATE_CSV_FAILURE';

// Action Creators
export const downloadCorporateCSVRequest = (payload) => ({
    type: DOWNLOAD_CORPORATE_CSV_REQUEST,
    payload
});


export const downloadCorporateCSVSuccess = () => ({
    type: DOWNLOAD_CORPORATE_CSV_SUCCESS
});

export const downloadCorporateCSVFailure = (error) => ({
    type: DOWNLOAD_CORPORATE_CSV_FAILURE,
    error
});
